import React from 'react';

const ErrorPage = ({ error }) => {
    return (
        <div>
            Error: {error.message}
        </div>
    );
};

export default ErrorPage;